import React from 'react';
import Webcam from "react-webcam";
import sunlight from '../images/sunlight.jpeg';
  
function Sunlight() {
    return (
      <div className="App">
        <img src={sunlight} style={{width:'70%', height:'70%'}} alt="sunlight" />
      </div>
    );
}
  
  export default Sunlight;
  